<template>
  <div :class="classes()">
    <InViewAnimation>
      <Headline
        v-if="!reduced"
        :staticClass="`${el}__headline`"
        slot="1"
        size="xs"
        responsive
        centered
      >
        {{ $t('careLevelChecker.headline') }}
      </Headline>

      <BaseRadio
        slot="2"
        id="careLevelChecker-1"
        name="careLevelChecker"
        :label="$t('careLevelChecker.radio1.label')"
        checkmark
        advanced
        :checked="careLevelSituation === 0"
        @input="onChangeCareLevelSituation(0)"
        tabindex="0"
        @keyup.enter.native="onChangeCareLevelSituation(0)"
        @keyup.space.native="onChangeCareLevelSituation(0)"
        role="radio"
        :aria-checked="careLevelSituation === 0"
      />

      <BaseRadio
        slot="3"
        id="careLevelChecker-2"
        name="careLevelChecker"
        :label="$t('careLevelChecker.radio2.label')"
        checkmark
        advanced
        hasMargin
        :checked="careLevelSituation === 1"
        @input="onChangeCareLevelSituation(1)"
        tabindex="0"
        @keyup.enter.native="onChangeCareLevelSituation(1)"
        @keyup.space.native="onChangeCareLevelSituation(1)"
        role="radio"
        :aria-checked="careLevelSituation === 1"
      />

      <BaseRadio
        slot="4"
        id="careLevelChecker-3"
        name="careLevelChecker"
        :label="$t('careLevelChecker.radio3.label')"
        checkmark
        advanced
        hasMargin
        :checked="careLevelSituation === 2"
        @input="onChangeCareLevelSituation(2)"
        tabindex="0"
        @keyup.enter.native="onChangeCareLevelSituation(2)"
        @keyup.space.native="onChangeCareLevelSituation(2)"
        role="radio"
        :aria-checked="careLevelSituation === 2"
      />

      <div v-if="noCopy && careLevelSituation === 2" slot="5" :class="`${el}__careLevel`">
        <Divider dotted />
        <Copy element="div" :staticClass="`${el}__noCareLevelCopy`">
          {{ noCopy }}
        </Copy>
      </div>

      <div
        class="u-margin__top--3"
        v-if="careLevelSituation === 0 || careLevelSituation === 1"
        slot="5"
      >
        <Divider dotted />
        <CareLevelForm
          @onChangeCareLevel="onChangeCareLevel"
          @onChangeCareLevelDate="onChangeCareLevelDate"
          :defaultCareLevel="careLevel"
          :defaultCareLevelDate="careLevelDate"
          controlled
        />
      </div>

      <Button
        v-if="!reduced"
        slot="6"
        :class="`${el}__button`"
        :label="ctaLabel"
        :disabled="
          careLevelSituation === null ||
          (careLevelSituation === 1 && !hasCareLevel) ||
          (careLevelSituation === 0 && !hasCareLevel)
        "
        @click="$emit('onClickCta')"
        :loading="loading"
        small
      />

      <Button
        v-if="back && !reduced"
        slot="7"
        :href="back"
        :label="$t('careLevelChecker.backButton')"
        type="text"
        :onClick="() => $emit('trackBackBtnClick')"
      />

      <Illustration
        v-if="!reduced"
        slot="8"
        :class="`${el}__illustration`"
        name="teaser-5"
        :brush="3"
        :brushScale="1"
        :illuScale="2"
        noLazy
      />
    </InViewAnimation>
  </div>
</template>

<script>
import Divider from '@/objects/Divider';
import Button from '@/objects/Button';
import Copy from '@/objects/Copy';
import Headline from '@/objects/Headline';
import Illustration from '@/objects/Illustration';
import BaseRadio from '@/objects/Forms/BaseRadio';
import InViewAnimation from '@/components/InViewAnimation';

import CareLevelForm from './CareLevelForm';

import { mapFieldsHealth } from '@/store/mapFields';

import { HEALTH_SET_CARE_LEVEL } from '@/store/actions/health';

export default {
  name: 'CareLevelChecker',
  props: {
    reduced: {
      type: Boolean,
      default: false,
    },
    noCopy: {
      type: String,
      default: null,
    },
    ctaLabel: {
      type: String,
      default: 'Weiter',
    },
    back: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Divider,
    Button,
    Copy,
    Headline,
    Illustration,
    BaseRadio,
    InViewAnimation,
    CareLevelForm,
  },
  data() {
    return {
      el: 'c-careLevelChecker',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
  computed: {
    ...mapFieldsHealth(['careLevelSituation', 'careLevel', 'careLevelDate']),

    hasCareLevel() {
      return this.careLevel !== null;
    },
  },
  watch: {
    careLevelSituation() {
      this.$store.dispatch(HEALTH_SET_CARE_LEVEL, {
        careLevel: null,
        careLevelDate: null,
      });
    },
  },
  methods: {
    onChangeCareLevelSituation(idx) {
      this.$store.dispatch(HEALTH_SET_CARE_LEVEL, {
        careLevelSituation: idx,
      });
    },

    onChangeCareLevelDate(careLevelDate) {
      this.$store.dispatch(HEALTH_SET_CARE_LEVEL, {
        careLevelDate,
      });
    },

    onChangeCareLevel(careLevel) {
      this.$store.dispatch(HEALTH_SET_CARE_LEVEL, {
        careLevel,
      });
    },
  },
};
</script>
